import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';

import { UserDefinedPoolModel } from '../types/PoolModel';
import { AddNewPoolButton } from './AddNewPoolButton';
import { DataConnectMultiPoolTableBody } from './DataConnectMultiPoolTableBody';
import { DataConnectMultiPoolTableHeaders } from './DataConnectMultiPoolTableHeaders';


export type DataConnectMultiPoolSectionProps = Readonly<{
  pools: Record<string, UserDefinedPoolModel>;
  siteId: string;
  refreshBaasEdgePools: () => void;
  hasLoadedBaasEdgePools: boolean;
}>

export function DataConnectMultiPoolSection(props: DataConnectMultiPoolSectionProps) {
  const existingPoolNames = Object.values(props.pools).map((pool: UserDefinedPoolModel) => pool.displayName);

  return (FeatureFlags.edgeMultiPoolEnabled ?
    <div className={sectionExtraPaddingBottom}>
      <AddNewPoolButton
        existingPoolNames={existingPoolNames}
        siteId={props.siteId}
        refreshEdgePools={props.refreshBaasEdgePools}
        hasLoadedEdgePools={props.hasLoadedBaasEdgePools}
      />
      <table className={`${multiPoolTableStyle} tb-static-grid-table-remote-agents-width`}>
        <DataConnectMultiPoolTableHeaders />
        <DataConnectMultiPoolTableBody
          pools={props.pools}
          existingPoolNames={existingPoolNames}
          siteId={props.siteId}
          refreshBaasEdgePools={props.refreshBaasEdgePools}
          hasLoadedBaasEdgePools={props.hasLoadedBaasEdgePools}
        />
      </table>
    </div>
    :
    null
  );
}

export const sectionExtraPaddingBottom = style({
  paddingBottom: TabStyles.Spacing.MediumSpace
});

export const multiPoolTableStyle = style({
  borderSpacing: 0,
  textAlign: 'left',
  backgroundColor: TabStyles.Colors.White,
  cursor: 'default'
});
